import data from './nameData'

const fakeData=[...data];
export default fakeData;